var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOption({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.375 1.625C3.30393 1.625 1.625 3.30393 1.625 5.375C1.625 7.44607 3.30393 9.125 5.375 9.125C7.44607 9.125 9.125 7.44607 9.125 5.375C9.125 3.30393 7.44607 1.625 5.375 1.625ZM0.625 5.375C0.625 2.75165 2.75165 0.625 5.375 0.625C7.99835 0.625 10.125 2.75165 10.125 5.375C10.125 7.99835 7.99835 10.125 5.375 10.125C2.75165 10.125 0.625 7.99835 0.625 5.375Z",
    fill: "#008731"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.625 5.34375C7.55393 5.34375 5.875 7.02268 5.875 9.09375C5.875 11.1648 7.55393 12.8438 9.625 12.8438C11.6961 12.8438 13.375 11.1648 13.375 9.09375C13.375 7.02268 11.6961 5.34375 9.625 5.34375ZM4.875 9.09375C4.875 6.4704 7.00165 4.34375 9.625 4.34375C12.2484 4.34375 14.375 6.4704 14.375 9.09375C14.375 11.7171 12.2484 13.8438 9.625 13.8438C7.00165 13.8438 4.875 11.7171 4.875 9.09375Z",
    fill: "#008731"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/option.01f92a79.svg";
export { ForwardRef as ReactComponent };